// This is where you can put your custom JavaScript code
// You can gradually migrate your existing JavaScript from Sprockets to here

document.addEventListener('DOMContentLoaded', () => {
  // Inject video thumbnails into SearchKit results
  function injectSearchkitVideos() {
    document.querySelectorAll('.result').forEach(function(result) {
      if (result.querySelector('.result-video-top') || result.querySelector('.result-video')) return;
      // Find hit JSON on parent SK hit item
      var hitItem = result.closest('[data-sk-hit]');
      if (!hitItem) return;
      try {
        var hit = JSON.parse(hitItem.getAttribute('data-sk-hit'));
        var videoUrl = hit.source.video_embed_url;
        var thumbUrl = hit.source.video_thumbnail_url;
        // Mobile block
        var mobile = document.createElement('div');
        mobile.className = 'media-right result-media visible-xs';
        mobile.innerHTML = '<a class="fancybox-media" href="'+videoUrl+'">'
          + '<div class="result-video-top media-object" style="background-image:url('+thumbUrl+');">'
          + '<img src="https://dz8pdz0wfluv5.cloudfront.net/assets/videoplay.png" alt="Play video">'
          + '</div></a>';
        // Desktop block
        var desktop = document.createElement('div');
        desktop.className = 'media-right result-media hidden-xs';
        desktop.innerHTML = '<a class="fancybox-media" href="'+videoUrl+'">'
          + '<div class="result-video media-object" style="background-image:url('+thumbUrl+');">'
          + '<img src="https://dz8pdz0wfluv5.cloudfront.net/assets/videoplay.png" alt="Play video">'
          + '</div></a>';
        var media = result.querySelector('.media');
        var left = media.querySelector('.media-left');
        if (left) media.insertBefore(mobile, left);
        var body = media.querySelector('.media-body');
        if (body) media.insertBefore(desktop, body.nextSibling);
        // Init fancybox v2 on the newly injected links
        $(result).find('.fancybox-media').fancybox({
          openEffect: 'none',
          closeEffect: 'none',
          helpers: { media: {} }
        });
      } catch(e) {
        console.error('Error injecting video:', e);
      }
    });
  }

  // Observe SearchKit hits list
  var hitsList = document.querySelector('.sk-hits-list');
  if (hitsList) {
    var observer = new MutationObserver(injectSearchkitVideos);
    observer.observe(hitsList, { childList: true, subtree: true });
    // Initial injection
    injectSearchkitVideos();
  }
})

// Add your existing JavaScript functions here
// Migrated releaseMe function from application.html.haml
window.releaseMe = function(id) {
  // Check if we're in production environment
  if (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
    var today = new Date();
    today = today.toISOString();
    var payload = {
      song: id,
      client_time: today,
      key: Math.random().toString(36).substring(7),
      url: (window.location.hostname + window.location.pathname),
    };
    
    // Add the hashCode function if it doesn't exist
    if (!String.prototype.hashCode) {
      String.prototype.hashCode = function() {
        var hash = 0, i, chr;
        if (this.length === 0) return hash;
        for (i = 0; i < this.length; i++) {
          chr = this.charCodeAt(i);
          hash = ((hash << 5) - hash) + chr;
          hash |= 0; // Convert to 32bit integer
        }
        return hash;
      };
    }
    
    payload["signature"] = (payload["client_time"] + payload["key"]).hashCode();
    
    // Format parameters function
    function formatParams(params) {
      return "?" + Object.keys(params).map(function(key) {
        return key + "=" + encodeURIComponent(params[key]);
      }).join("&");
    }
    
    var params = formatParams(payload);
    var xhttp = new XMLHttpRequest();
    xhttp.open("GET", "https://gigstarter.eu/logging" + params, true);
    xhttp.send();
  }
} 